import React from "react";

const StubLanding = () => (
  <div
    className="min-h-screen flex flex-col items-center justify-center bg-slate-900 text-slate-100 font-mono px-6 py-12"
    data-testid="stub-landing"
  >
    <main className="w-full max-w-2xl border border-slate-700/60 rounded-lg p-8 md:p-10 space-y-6">
      <h1 className="text-lg md:text-xl font-medium tracking-tight leading-snug">
        Alex S. <span className="text-slate-400">//</span> Systems &amp; Cloud Infrastructure
        Architect
      </h1>
      <div className="space-y-4 text-slate-300 text-sm leading-relaxed">
        <p>
          I design and deploy high-performance cloud infrastructure, automated backend pipelines,
          and data routing systems for tech companies.
        </p>
        <p>Currently fully booked and not accepting new consulting projects or clients.</p>
        <p>
          If you need to reach me regarding personal matters or ongoing work, please drop a message
          to my primary email address.
        </p>
      </div>
    </main>
  </div>
);

export default StubLanding;
